/**
 * @desc factoryStock
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockAgeFacadeImpl.factoryStock.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockAge/factoryStock`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
